import React, {FC, ReactNode} from 'react';
import {Form} from 'react-bootstrap';

type Props = {
    label: string;
    description?: ReactNode;
    controlId?: string;
    last?: boolean;
    children: ReactNode;
};

export const AbuseWordModalFormSection: FC<Props> = ({label, description, controlId, last, children}) => (
    <Form.Group className={last ? "mb-0" : "mb-3 pb-3 border-bottom"} controlId={controlId}>
        <Form.Label className="fw-medium">{label}</Form.Label>
        {children}
        {description && <Form.Text muted className="d-block mt-1">{description}</Form.Text>}
    </Form.Group>
);
